export function formatTransferNo(docNo: number) {
  return String(docNo).padStart(5, "0")
}
